import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { DirectApplicantsPerPhaseNumber } from '@shared/models/direct-applicants-per-phase-number';
import { getDirectApplicantsPerPhaseNumbers } from '@modules/job-page/store';
import { Store } from '@ngrx/store';

@Component({
  selector: 'mojo-pipeline-total-direct-per-phases',
  styleUrls: ['./pipeline-total-direct-per-phases.component.scss'],
  templateUrl: './pipeline-total-direct-per-phases.component.html',
})
export class PipelineTotalDirectPerPhasesComponent {
  @Input() totalDirectPerPhasesData: any;

  phases$: Observable<DirectApplicantsPerPhaseNumber[]> = this.store.select(
    getDirectApplicantsPerPhaseNumbers,
  );

  constructor(private store: Store<{}>) {}
}
